import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Zap, Battery, Wind, Sun } from 'lucide-react';

const EnergyServices = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Energy & Utilities Solutions | AuVSys</title>
        <meta name="description" content="Modernize energy infrastructure with smart grid solutions, renewable energy management, and utility optimization." />
      </Helmet>

      <div className="energy-services">
        <section className="hero-section">
          <div className="container">
            <div className="hero-content">
              <h1>Energy & Utilities</h1>
              <p>Modernize energy infrastructure with smart grid solutions, renewable energy management, and advanced utility optimization technologies.</p>
            </div>
          </div>
        </section>

        <section className="services-grid">
          <div className="container">
            <div className="grid">
              <div className="service-card">
                <Zap className="service-icon" />
                <h3>Smart Grid Solutions</h3>
                <p>Intelligent grid management with real-time monitoring and automated distribution.</p>
              </div>
              <div className="service-card">
                <Battery className="service-icon" />
                <h3>Energy Storage Systems</h3>
                <p>Advanced battery management and energy storage optimization solutions.</p>
              </div>
              <div className="service-card">
                <Wind className="service-icon" />
                <h3>Renewable Integration</h3>
                <p>Seamless integration of solar, wind, and other renewable energy sources.</p>
              </div>
              <div className="service-card">
                <Sun className="service-icon" />
                <h3>Asset Management</h3>
                <p>Predictive maintenance and lifecycle management for energy infrastructure.</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default EnergyServices;